import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Anchor } from "lucide-react";

// Loads an access-controlled image via the API (sends auth cookie) as a blob.
export default function AuthImage({ path, src, alt = "", className = "", fallback = null }) {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let active = true;
    let objUrl = null;
    setErr(false);
    setUrl(null);
    if (!path && !src) { setErr(true); return; }
    api.get(src || `/image/${path}`, { responseType: "blob" })
      .then((res) => {
        if (!active) return;
        objUrl = URL.createObjectURL(res.data);
        setUrl(objUrl);
      })
      .catch(() => active && setErr(true));
    return () => { active = false; if (objUrl) URL.revokeObjectURL(objUrl); };
  }, [path, src]);

  if (err || (!path && !src)) {
    return (
      fallback || (
        <div className={`flex items-center justify-center bg-secondary text-muted-foreground ${className}`}>
          <Anchor className="h-1/2 w-1/2 opacity-40" />
        </div>
      )
    );
  }
  if (!url) return <div className={`bg-secondary animate-pulse ${className}`} />;
  return <img src={url} alt={alt} className={className} />;
}
